// 這是Webpack掛載起始點
import Index from './index.vue'
import Show from '../.components/customer/show.vue'

const main_router = 'customer_operations'
const show_router = 'show_customer_operation'

const router = [
    {
        path: '',
        component: Index,
        name: 'customer_operations',
        meta: {
            breadcrumb: [main_router]
        }
    },
    {
        path: ':identity',
        component: Show,
        name: 'show_customer_operation',
        meta: {
            breadcrumb: [main_router, show_router]
        }
    },
]

export default router
